import { GroupTableType } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import page from "report/common/page";
import paginate from "report/common/pagenation";
import getEchart from "../echart/echart";

const get = async (
  t: any,
  grouped: GroupTableType,
  title: string,
): Promise<Content[]> => {
  const groupedArray = paginate(grouped);

  const proArray = groupedArray.map(async (e) => await getEchart(t, e, title));

  const pageArray = await Promise.all(proArray);

  // const pageData = pageArray.reduce((acc, cur, index) => {
  //   return [...acc, cur, page()];
  // }, [] as Content[]);

  return pageArray;
};

export default get;
